import { Close } from '@mui/icons-material';
import React from 'react';
import { useDeclineJobMutation } from '../../../../app/Slices/SevenDayApiSlice';
import { Job } from '../../../../app/Slices/SevenDayApiTypes';
import toast from '../../../shared/Toast';
import { ModalProps } from '../../../types/modal';
import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Stack,
    Typography,
} from '@mui/material';

interface DeclineModalProps extends ModalProps {
    job?: Job;
}

const DeclineModal = ({ open, onClose, job }: DeclineModalProps) => {
    const [declineJob] = useDeclineJobMutation();

    const handleDecline = async () => {
        try {
            if (!job) return;

            await declineJob(job.id).unwrap();

            toast.success('Job declined successfully');
            onClose();
        } catch (error) {
            toast.error('Error declining job');
        }
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>
                Decline Job
                <IconButton
                    onClick={onClose}
                    sx={{ color: 'text.primary' }}
                    aria-label='close'
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Stack spacing={1}>
                    <Typography>
                        Are you sure you want to decline this job?
                    </Typography>
                    <Alert severity='warning'>
                        This action cannot be undone
                    </Alert>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' onClick={onClose}>
                    Cancel
                </Button>
                <Button
                    variant='contained'
                    color='error'
                    onClick={handleDecline}
                >
                    Decline
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeclineModal;
